export const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

export const plural = (word, count) => {
	if (count === 1) {
		return word;
	}

	if (word.slice(-1) === 'y') {
		let start = word.slice(0, -1);
		return `${start}ies`;
	}

	if (word.slice(-1) === 'o') {
		let start = word.slice(0, -1);
		return `${start}oes`;
	}

	if (word.slice(-1) === 'x') {
		let start = word.slice(0, -1);
		return `${start}xes`;
	}

	return `${word}s`;
};

export const stripTags = (html) => {
	if (typeof document !== 'object') return html;
	var tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	return tmp.textContent || tmp.innerText || "";
};

export const snake2string = word => capitalize(word).split("_").join(" ");

/**
 * truncateToNearestWord truncates a given string to the end of the nearest word at the
 * given character limit. 
 * @param {String} inpString 
 * @param {Number} characterLimit 
 * @returns {String} String
 */
export const truncateToNearestWord = (inpString, characterLimit) => {
	if (!characterLimit) return inpString;
	if (!inpString) return inpString;

	if (inpString.length < characterLimit) return inpString;

	const STOP_CHARACTERS = [" ", ".", "!", "?", ","];

	let truncateIndex = characterLimit;
	let truncatedString = inpString.slice(0, truncateIndex);

	// If we land on a STOP_CHARACTER then back it up to try and makea nicer string
	while (STOP_CHARACTERS.indexOf(truncatedString[truncateIndex]) != -1) {
		if (truncateIndex - 1 <= 0) break;
		truncateIndex--;
		truncatedString = inpString.slice(0, truncateIndex);
	}

	// If we're in the middle of a word, lets include the full word
	while (STOP_CHARACTERS.indexOf(truncatedString[truncatedString.length - 1]) == -1) {
		if (truncateIndex + 1 === inpString.length || STOP_CHARACTERS.indexOf(inpString[truncateIndex]) != -1) break;
		truncateIndex++;
		truncatedString = inpString.slice(0, truncateIndex);
	}

	return truncatedString;
};
